/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClustersCarsContactsTracksFilter = {
            /**
            * Select clusters where `body` feature takes one of these values
            */
        body?: Array<'cab' | 'convertible' | 'coupe' | 'crossover' | 'limousine' | 'minibus' | 'minivan' | 'sedan' | 'suv' | 'wagon' | null>;
            /**
            * Select clusters associated with the specified camera groups
            */
        camera_groups?: Array<number>;
            /**
            * Select clusters associated with the specified cameras
            */
        cameras?: Array<number>;
            /**
            * Select clusters that matched card
            */
        card?: number;
            /**
            * Select clusters related to these cases
            */
        case_in?: Array<number | null>;
            /**
            * Select clusters where `category` feature takes one of these values
            */
        category_type?: Array<'A' | 'B' | 'BE' | 'C' | 'CE' | 'D' | 'DE' | 'other' | 'unknown' | null>;
            /**
            * Select clusters where `color` feature takes one of these values
            */
        color?: Array<'beige' | 'black' | 'blue' | 'brown' | 'cyan' | 'gold' | 'green' | 'grey' | 'orange' | 'pink' | 'purple' | 'red' | 'silver' | 'violet' | 'white' | 'yellow' | null>;
            /**
            * Select objects with `created_date` **greater** than this value
            */
        created_date_gt?: string;
            /**
            * Select objects with `created_date` **greater than or equal** to this value
            */
        created_date_gte?: string;
            /**
            * Select objects with `created_date` in last N days
            */
        created_date_last_n_days?: number;
            /**
            * Select objects with `created_date` **less** than this value
            */
        created_date_lt?: string;
            /**
            * Select objects with `created_date` **less than or equal** to this value
            */
        created_date_lte?: string;
            /**
            * Select objects with `created_date` in last Nth week (including Sunday and Saturday)
            */
        created_date_nth_full_week?: number;
            /**
            * Select objects with `created_date` in last Nth week (only working days, i.e. excluding Sunday and Saturday)
            */
        created_date_nth_work_week?: number;
            /**
            * Select objects related to `episode` Pass comma separated values to select related to multiple `episode`s)
            */
        episodes?: Array<number>;
            /**
            * Select objects with `any` event date **greater** than this value
            */
        event_date_gt?: string;
            /**
            * Select objects with `any` event date **greater than or equal** to this value
            */
        event_date_gte?: string;
            /**
            * Select objects with `any` event date **less** than this value
            */
        event_date_lt?: string;
            /**
            * Select objects with `any` event date **less than or equal** to this value
            */
        event_date_lte?: string;
            /**
            * Select clusters where cluster events count is **greater or equal than or equal** to this value
            */
        events_count_gte?: number;
            /**
            * Select clusters where cluster events count is **less or equal than or equal** to this value
            */
        events_count_lte?: number;
            /**
            * Select clusters where average cluster event quality is **greater or equal than or equal** to this value
            */
        events_quality_gte?: number;
            /**
            * Select clusters where average cluster event quality is **less or equal than or equal** to this value
            */
        events_quality_lte?: number;
            /**
            * Select objects with `first` event date **greater** than this value
            */
        first_event_date_gt?: string;
            /**
            * Select objects with `first` event date **greater than or equal** to this value
            */
        first_event_date_gte?: string;
            /**
            * Select objects with `first` event date **less** than this value
            */
        first_event_date_lt?: string;
            /**
            * Select objects with `first` event date **less than or equal** to this value
            */
        first_event_date_lte?: string;
            /**
            * `true` - select only clusters with a card. `false` - select only clusters without a card.
            */
        has_card?: boolean;
            /**
            * `true` - select only clusters relates to case. `false` - select only clusters without case.
            */
        has_case?: boolean;
            /**
            * Select clusters with provided ids
            */
        id_in?: Array<number>;
            /**
            * Parameter that determines track intersection threshold in seconds.
            */
        intersection_threshold?: number;
            /**
            * Select clusters where `license_plate_country` feature takes one of these values
            */
        license_plate_country?: Array<'AE' | 'AM' | 'AR' | 'AZ' | 'BR' | 'BY' | 'CZ' | 'EST' | 'FIN' | 'GE' | 'IN' | 'KG' | 'KZ' | 'LT' | 'LV' | 'MD' | 'MX' | 'PK' | 'RU' | 'SA' | 'SRB' | 'TH' | 'TJ' | 'TM' | 'UA' | 'UZ' | 'VN' | 'unknown' | null>;
            /**
            * Select clusters where `license_plate_number_color` feature takes one of these values
            */
        license_plate_number_color?: Array<string | null>;
            /**
            * Select cluster where the SQL condition `license_plate_number ILIKE license_plate_number_contains` is true
            */
        license_plate_number_contains?: string;
            /**
            * Select clusters where `license_plate_region` feature takes one of these values
            */
        license_plate_region?: Array<string | null>;
        limit: number;
            /**
            * Select clusters that contain object similar to: (`detection:<detection id>`, `{face, body or car}event:<event id>`, `{face, body or car}object:<object id>`, `{face, body or car}cluster:<cluster id>` or `caseparticipant:<caseparticipant id>`)
            */
        looks_like?: string;
            /**
            * Select clusters where `make` feature takes one of these values
            */
        make?: Array<'ac' | 'acura' | 'adler' | 'alfa_romeo' | 'alpina' | 'am_general' | 'amc' | 'aro' | 'asia' | 'aston_martin' | 'audi' | 'austin' | 'austin_healey' | 'avtokam' | 'baic' | 'bajaj' | 'bentley' | 'blakely' | 'bmw' | 'borgward' | 'bradley' | 'brilliance' | 'bugatti' | 'buick' | 'bus' | 'byd' | 'cadillac' | 'can_am' | 'chana' | 'changan' | 'changfeng' | 'changhe' | 'chery' | 'chevrolet' | 'chrysler' | 'citroen' | 'dacia' | 'dadi' | 'daewoo' | 'daihatsu' | 'daimler' | 'dallara' | 'datsun' | 'derways' | 'dkw' | 'dodge' | 'dongfeng' | 'doninvest' | 'ds' | 'dw_hower' | 'eagle' | 'excalibur' | 'faw' | 'ferrari' | 'fiat' | 'fisker' | 'ford' | 'foton' | 'gaz' | 'geely' | 'genesis' | 'geo' | 'gmc' | 'great_wall' | 'hafei' | 'haima' | 'hanomag' | 'haval' | 'hawtai' | 'holden' | 'honda' | 'horch' | 'huanghai' | 'hudson' | 'hummer' | 'hyundai' | 'ig' | 'infiniti' | 'international' | 'iran_khodro' | 'isuzu' | 'jac' | 'jaguar' | 'jeep' | 'jinbei' | 'jmc' | 'kamaz' | 'kia' | 'lamborghini' | 'lancia' | 'land_rover' | 'landwind' | 'lexus' | 'lifan' | 'lincoln' | 'lotus' | 'luaz' | 'luxgen' | 'mahindra' | 'maruti' | 'maserati' | 'maybach' | 'mazda' | 'mclaren' | 'mercedes' | 'mercury' | 'metrocab' | 'mg' | 'mini' | 'mitsubishi' | 'mitsuoka' | 'morgan' | 'morris' | 'moscvich' | 'nash' | 'nissan' | 'oldsmobile' | 'opel' | 'packard' | 'peugeot' | 'plymouth' | 'polaris' | 'pontiac' | 'porsche' | 'proton' | 'puch' | 'ram' | 'rambler' | 'ravon' | 'renault' | 'rimac' | 'rolls_royce' | 'rover' | 'saab' | 'samsung' | 'saturn' | 'scion' | 'seat' | 'shanghai_maple' | 'shuanghuan' | 'simca' | 'skoda' | 'smart' | 'smz' | 'spyker' | 'ssang_yong' | 'steyr' | 'studebaker' | 'subaru' | 'sunbeam' | 'suzuki' | 'tagaz' | 'talbot' | 'tata' | 'tatra' | 'tesla' | 'think' | 'tianma' | 'tianye' | 'toyota' | 'trabant' | 'triumph' | 'uaz' | 'vauxhall' | 'vaz' | 'volkswagen' | 'volvo' | 'vortex' | 'wanderer' | 'wartburg' | 'willis' | 'willys' | 'xinkai' | 'zaz' | 'zenvo' | 'zil' | 'zis' | 'zotye' | 'zx' | null>;
            /**
            * Select clusters that matched a card included in these watch lists
            */
        matched_lists?: Array<number>;
            /**
            * Select clusters where `model` feature takes one of these values
            */
        model?: Array<string | null>;
            /**
            * Какое поле использовать для сортировки результатов. Available fields: `id`, `created_date`, `looks_like_confidence`
            */
        ordering?: string;
            /**
            * Pagination cursor value.
            */
        page?: string;
            /**
            * Select only pinned clusters
            */
        pinned?: boolean;
            /**
            * Select clusters where `special_vehicle_type` feature takes one of these values
            */
        special_vehicle_type?: Array<'ambulance' | 'car_sharing' | 'gas_service' | 'military' | 'not_special' | 'other_special' | 'police' | 'rescue_service' | 'road_service' | 'route_transport' | 'taxi' | null>;
            /**
            * Similarity threshold for `looks_like`
            */
        threshold?: number;
            /**
            * Select clusters with provided tnt ids
            */
        tnt_id_in?: Array<number | null>;
            /**
            * Select clusters where `weight_type` feature takes one of these values
            */
        weight_type?: Array<'B_heavy' | 'B_light' | 'C_heavy' | 'C_light' | 'D_light' | 'D_long' | 'other' | null>;
}
export const EmptyClustersCarsContactsTracksFilter: ClustersCarsContactsTracksFilter = {
        body: [],
        camera_groups: [],
        cameras: [],
        card: undefined,
        case_in: [],
        category_type: [],
        color: [],
        created_date_gt: undefined,
        created_date_gte: undefined,
        created_date_last_n_days: undefined,
        created_date_lt: undefined,
        created_date_lte: undefined,
        created_date_nth_full_week: undefined,
        created_date_nth_work_week: undefined,
        episodes: [],
        event_date_gt: undefined,
        event_date_gte: undefined,
        event_date_lt: undefined,
        event_date_lte: undefined,
        events_count_gte: undefined,
        events_count_lte: undefined,
        events_quality_gte: undefined,
        events_quality_lte: undefined,
        first_event_date_gt: undefined,
        first_event_date_gte: undefined,
        first_event_date_lt: undefined,
        first_event_date_lte: undefined,
        has_card: undefined,
        has_case: undefined,
        id_in: [],
        intersection_threshold: undefined,
        license_plate_country: [],
        license_plate_number_color: [],
        license_plate_number_contains: undefined,
        license_plate_region: [],
        limit: 20,
        looks_like: undefined,
        make: [],
        matched_lists: [],
        model: [],
        ordering: undefined,
        page: undefined,
        pinned: undefined,
        special_vehicle_type: [],
        threshold: undefined,
        tnt_id_in: [],
        weight_type: [],
}